<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M4 20V4H12V5.77778H5.77778V18.2222H12V20H4ZM15.5556 16.4444L14.3333 15.1556L16.6 12.8889H9.33333V11.1111H16.6L14.3333 8.84444L15.5556 7.55556L20 12L15.5556 16.4444Z"
      fill="currentColor"
    />
  </svg>
</template>
